import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CreativesLibraryState} from './creativesLibrary.types';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {Creative} from '../../creatives.types';
import {SharePermission} from 'common/src/modules/sharing/sharing.index';

const creativesLibraryInitialState: CreativesLibraryState = {
  creatives: [],
  sharePermissions: [],
  isPreviewOpen: false,
  selectedCreativesIds: [],
  aiFilter: {
    aiFilteredIds: [],
    query: '',
  },
};

const creativesLibraryReducer = createSlice({
  name: BreadcrumbName.CreativesLibrary,
  initialState: creativesLibraryInitialState,
  reducers: {
    resetState: () => creativesLibraryInitialState,
    setCreativesLibraryData: (
      state,
      action: PayloadAction<{creatives: Creative[]; sharePermissions: SharePermission[]}>,
    ) => {
      state.creatives = action.payload.creatives;
      state.sharePermissions = action.payload.sharePermissions;
    },
    closePreview: (state) => {
      state.selectedCreativesIds = [];
      state.isPreviewOpen = false;
    },
    setSelectedCreativesIds: (state, action: PayloadAction<number[]>) => {
      state.selectedCreativesIds = action.payload;
    },

    showPreviewForCreativeId: (state, action: PayloadAction<number>) => {
      state.selectedCreativesIds = [action.payload];
      state.isPreviewOpen = true;
    },
    setAiCreativesFilter: (
      state,
      action: PayloadAction<{aiFilteredIds: number[]; query: string}>,
    ) => {
      state.aiFilter = action.payload;
    },
  },
});

const {
  resetState,
  setCreativesLibraryData,
  closePreview,
  setSelectedCreativesIds,
  setAiCreativesFilter,
  showPreviewForCreativeId,
} = creativesLibraryReducer.actions;

export {
  resetState,
  setCreativesLibraryData,
  closePreview,
  setSelectedCreativesIds,
  showPreviewForCreativeId,
  setAiCreativesFilter,
};

export default creativesLibraryReducer.reducer;
